import cogRefreshIcon from "@assets/images/cog-refresh.svg";
import { Button, makeStyles } from "@material-ui/core";
import PageHeader from "@saleor/components/PageHeader";
import { sectionNames } from "@saleor/intl";
import { DeliveryTypeEnum } from "@saleor/types/globalTypes";
import React from "react";
import SVG from "react-inlinesvg";
import { FormattedMessage, useIntl } from "react-intl";

const useStyles = makeStyles(
  _ => ({
    pageHeader: {
      display: "block"
    },
    pageHeaderButton: {
      "& span": {
        color: "#0030FF"
      },
      "&:hover": {
        backgroundColor: "white",
        borderColor: "#0030FF"
      },
      backgroundColor: "white",
      borderColor: "#0030FF",
      margin: "0 10px 0px 0px"
    },
    pageHeaderButtonActive: {
      "& span": {
        color: "white"
      },
      "&:hover": {
        backgroundColor: "#0030FF"
      },
      backgroundColor: "#0030FF",
      margin: "0 10px 0px 0px"
    },
    pageHeaderButtonCogRefresh: {
      "& span": {
        color: "#0030FF",
        marginTop: "3px"
      },
      alignItems: "center",
      backgroundColor: "white",
      borderColor: "#0030FF",
      borderRadius: "100%",
      cursor: "pointer",
      display: "flex",
      height: "36.5px",
      justifyContent: "center",
      margin: "0",
      marginRight: "10px",
      width: "36.5px"
    },
    pageHeaderButtons: {
      alignItems: "center",
      display: "flex",
      justifyContent: "flex-start",
      marginTop: "15px"
    },
    pageHeaderChildren: {
      display: "block"
    },
    pageHeaderSubtitle: {
      margin: 0
    },
    pageHeaderTimer: {
      color: "#0030FF"
    }
  }),
  {
    name: "MasterFulfillmentPageHeader"
  }
);

interface MasterFulfillmentPageHeaderProps {
  optionsDelTypes: Array<{
    label: string;
    value: DeliveryTypeEnum;
  }>;
  selectedDelTypes: string[];
  activeDelType: string;
  onClickedOpenDelTypesModal: (delTypes: string[]) => void;
  onActiveDelType: (delType: string) => void;
}

const MasterFulfillmentPageHeader: React.FC<MasterFulfillmentPageHeaderProps> = props => {
  const {
    optionsDelTypes,
    selectedDelTypes,
    activeDelType,
    onClickedOpenDelTypesModal,
    onActiveDelType
  } = props;
  const intl = useIntl();
  const classes = useStyles(props);

  const handleDisplayValue = value =>
    optionsDelTypes.find(item => item.value === value)?.label;

  const handleDisplay = (str: string) =>
    handleDisplayValue(str)
      .replace("Delivery", "")
      .trim();

  return (
    <PageHeader
      className={classes.pageHeader}
      title={intl.formatMessage(sectionNames.fulfillment)}
    >
      <div className={classes.pageHeaderChildren}>
        <div className={classes.pageHeaderSubtitle}>
          Page will auto-refresh after{" "}
          <span className={classes.pageHeaderTimer}>00:05:00</span>
        </div>
        <div className={classes.pageHeaderButtons}>
          <Button
            variant="outlined"
            className={
              !activeDelType
                ? classes.pageHeaderButtonActive
                : classes.pageHeaderButton
            }
            onClick={() => onActiveDelType("")}
          >
            <FormattedMessage defaultMessage="All Types" description="button" />
          </Button>
          {selectedDelTypes.map((delType, index) => (
            <Button
              key={"selectedDelTypesButton" + index}
              variant="outlined"
              className={
                activeDelType === delType
                  ? classes.pageHeaderButtonActive
                  : classes.pageHeaderButton
              }
              onClick={() => onActiveDelType(delType)}
            >
              {handleDisplay(delType)}
            </Button>
          ))}
          <div
            className={classes.pageHeaderButtonCogRefresh}
            onClick={() => onClickedOpenDelTypesModal(selectedDelTypes)}
          >
            <SVG src={cogRefreshIcon} />
          </div>
        </div>
      </div>
    </PageHeader>
  );
};

export default MasterFulfillmentPageHeader;
